import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, IconButton } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { useCallback, useState } from 'react';
import { getNextMonthWithYear, getPreviousMonthWithYear, } from 'components/settings/components/sections/openingHours/views/schedule/utils/date';
import { useScheduleContext } from '../../../../schedule.context';
import { Calendar } from '../calendar/calendar';
import { getCurrentDate } from '../calendar/utils/date';
import styles from './preview.module.scss';
const monthNames = moment.months();
const { year: currentYear, month: currentMonth } = getCurrentDate();
export function Preview() {
    const [monthAndYear, setMonthAndYear] = useState({
        year: currentYear,
        month: currentMonth,
    });
    const { initialSchedule } = useScheduleContext();
    const onPreviousMonth = useCallback(() => void setMonthAndYear((prevMonthAndYear) => getPreviousMonthWithYear(prevMonthAndYear)), []);
    const onNextMonth = useCallback(() => void setMonthAndYear((prevMonthAndYear) => getNextMonthWithYear(prevMonthAndYear)), []);
    const isBeforeScheduleCreated = moment
        .utc(monthAndYear)
        .isBefore(moment.utc(initialSchedule === null || initialSchedule === void 0 ? void 0 : initialSchedule.created_at));
    const isPreviousDisabled = (monthAndYear.year === currentYear - 1 &&
        monthAndYear.month === currentMonth) ||
        isBeforeScheduleCreated;
    const isNextDisabled = monthAndYear.year === currentYear + 1 &&
        monthAndYear.month === currentMonth;
    return (_jsxs(FlexBox, Object.assign({ maxHeight: "100%", flexDirection: "column" }, { children: [_jsxs("div", Object.assign({ className: styles.head }, { children: [_jsx("h2", Object.assign({ className: styles.heading }, { children: `${monthNames[monthAndYear.month]} ${monthAndYear.year}` })), _jsxs(FlexBox, Object.assign({ gap: "100" }, { children: [_jsx(IconButton, { className: styles.arrow, disabled: isPreviousDisabled, icon: "angle-left", onClick: onPreviousMonth, size: "large", variant: "secondary" }), _jsx(IconButton, { className: styles.arrow, disabled: isNextDisabled, icon: "angle-right", onClick: onNextMonth, size: "large", variant: "secondary" })] }))] })), _jsx(Calendar, { monthAndYear: monthAndYear })] })));
}
